/* eslint-disable no-undef */
import SETTINGS from '../../settings';

const TAG = 'Intercom';

const ItercomScript = {
  identify(userId, email, name) {
    try {
      window.Intercom('boot', {
        app_id: SETTINGS.SCRIPTS.INTERCOM_APP_ID,
        user_id: userId || undefined,
        name: name || undefined,
        email: email || undefined,
      });
    } catch (e) {
      console.log(TAG, 'identify', e);
    }
  },
};

export default ItercomScript;
